import { Directive } from '@angular/core';
import { NG_VALIDATORS, FormControl } from '@angular/forms';
import * as moment from 'moment';

export function required(control: FormControl) {
    let entryField = control.value;
    
    if (entryField) {
        console.log("entryField");
        console.log(entryField);
        if(entryField != null || entryField == ''){

            return {
                customRequired : true
            }
   
        }        
     }
    return null;
}

@Directive({
    selector: '[customRequiredValidator][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useValue: required,
            multi: true
        }
    ]
})
export class CustomRequiredValidator {
}